import React from 'react';
import { DollarSign, Lock } from 'lucide-react';
import { PRIVATE_PAYOUT_EXCLUDED_NOTE } from '../../../utils/bookingSource';

const RevenueBreakdown = ({ revenueAnalytics = {}, overview = {} }) => {
  const formatCurrency = (amount) => {
    if (amount === null || amount === undefined || amount === '') return '$0.00';
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : Number(amount);
    if (isNaN(numAmount) || !isFinite(numAmount)) return '$0.00';
    return `$${numAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };

  const platformRevenue =
    revenueAnalytics.platform_revenue ??
    overview.platform_revenue ??
    revenueAnalytics.total_revenue ??
    overview.total_revenue ??
    0;
  const privateOffline =
    revenueAnalytics.private_offline_collected ?? overview.private_offline_collected ?? 0;

  return (
    <div className="rounded-2xl border border-gray-200/80 bg-white dark:border-gray-700 dark:bg-gray-900 shadow-sm p-4 sm:p-6">
      <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-50 mb-1">Revenue Breakdown</h2>
      <p className="text-xs text-gray-500 dark:text-gray-400 mb-4">Platform totals exclude private offline bookings</p>
      <div className="space-y-4">
        <div className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-800/50 !rounded-xl">
          <div>
            <p className="text-sm text-gray-600 dark:text-gray-400">Platform revenue</p>
            <p className="text-xl font-bold text-gray-900 dark:text-gray-50 mt-1">{formatCurrency(platformRevenue)}</p>
            <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">Collected via platform payments</p>
          </div>
          <DollarSign className="w-8 h-8 text-emerald-600 dark:text-emerald-400" />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div className="p-3 bg-gray-50 dark:bg-gray-800/50 !rounded-xl">
            <p className="text-xs text-gray-600 dark:text-gray-400 mb-1">Platform fees</p>
            <p className="text-lg font-semibold text-gray-900 dark:text-gray-50">
              {formatCurrency(revenueAnalytics.platform_fees || overview.platform_fees || 0)}
            </p>
          </div>
          <div className="p-3 bg-gray-50 dark:bg-gray-800/50 !rounded-xl">
            <p className="text-xs text-gray-600 dark:text-gray-400 mb-1">Vendor payouts</p>
            <p className="text-lg font-semibold text-gray-900 dark:text-gray-50">
              {formatCurrency(revenueAnalytics.vendor_payouts || 0)}
            </p>
          </div>
        </div>
        {privateOffline > 0 && (
          <div className="flex items-center justify-between p-3 bg-indigo-50 dark:bg-indigo-950/40 border border-indigo-100 dark:border-indigo-800/50 !rounded-xl">
            <div>
              <p className="text-sm text-indigo-800 dark:text-indigo-300 font-medium">Private offline collected</p>
              <p className="text-lg font-semibold text-indigo-900 dark:text-indigo-200 mt-1">{formatCurrency(privateOffline)}</p>
              <p className="text-xs text-indigo-600 dark:text-indigo-400 mt-0.5">{PRIVATE_PAYOUT_EXCLUDED_NOTE}</p>
            </div>
            <Lock className="w-7 h-7 text-indigo-500 dark:text-indigo-400 shrink-0" />
          </div>
        )}
        {revenueAnalytics.average_transaction > 0 && (
          <div className="p-3 bg-gray-50 dark:bg-gray-800/50 !rounded-xl">
            <p className="text-xs text-gray-600 dark:text-gray-400 mb-1">Avg platform transaction</p>
            <p className="text-lg font-semibold text-gray-900 dark:text-gray-50">
              {formatCurrency(revenueAnalytics.average_transaction)}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default RevenueBreakdown;
